const VIDEO_EXTENSIONS = ['.mp4', '.mov', '.avi', '.webm', '.m4v'];

/**
 * Returns true if the given URL points to a video file based on its extension.
 * Comparison is case-insensitive to handle iOS uppercase extensions (e.g. .MOV).
 */
export const isVideoExtension = (url: string): boolean => {
  const lower = url.toLowerCase();
  return VIDEO_EXTENSIONS.some((ext) => lower.includes(ext));
};

/**
 * Returns true if the given MIME type represents a video.
 */
export const isVideoMimeType = (mimeType: string): boolean => {
  return mimeType.startsWith('video/');
};
